<rs-modal #modal
  (show)="show($event)"
  (submit)="submit()"
  (cancel)="cancel($event)"
  (hide)="hide()"
  [config]="modalConfig">
  <div class="pb-5">
    @if (benefitAlert && !loading) {
      <div>
        <rs-alert [alert]='benefitAlert'></rs-alert>
      </div>
    }
    <fieldset>
      <legend>
        <!--   <h4 class="fs-22"
      *ngIf="!loading">form.title{{ config.form.title | translate }}</h4> -->
    </legend>


    <form [formGroup]="insuranceForm"
      (ngSubmit)="submit()">
      <div class="insurance-form flex-grow-1">
        @if (config && forms) {
          <div
            class="container">
            @for (card of config.form.cards; track card; let i1 = $index) {
              <div class="card mb-3"
                >
                @if (card.title) {
                  <h2
                    class="service-status d-flex align-items-center fw-700 pb-3 mb-0">
                    {{ card.title | translate }}
                  </h2>
                }
                @if (card.subtitle) {
                  <div
                    class="info-block ml-5 pb-3 mb-5">
                    {{ card.subtitle | translate }}
                  </div>
                }
                @for (group of card.groups; track group; let i2 = $index; let lastGroup = $last) {
                  <div>
                    <!-- <h6 *ngIf="group.title"
                  class="pb-2 fw-700">{{ group.title | translate }}</h6> -->
                  @if (group.subtitle) {
                    <div
                      class="info-block ml-5 pb-3 mb-5">
                      {{ group.subtitle | translate }}
                    </div>
                  }
                  <rs-ui [config]="forms[i1][i2]"
                  #resolver></rs-ui>
                  @if (!lastGroup) {
                    <hr />
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </form>
</fieldset>
@if (loading && !benefit) {
  <div
    class="w-100 position-relative">
    <rs-spinner [loading]="true"
      wrapClass="spinner-border-lg spinner-center">
    </rs-spinner>
  </div>
}
@if (benefit && loading) {
  <div>
    <h4 class="fs-24 fw-700 pb-4 text-center">Verifying Information</h4>
    <div class="progress">
      <div class="progress-bar"
        role="progressbar"
        [ngStyle]="{'width.%': 100}"
        [attr.aria-valuenow]="100"
        aria-valuemin="0"
        aria-valuemax="100"
        min="0"
        max="100"
        [attr.aria-valuemin]="0"
        [attr.aria-valuemax]="100">
      </div>
    </div>
  </div>
}

@if (benefit && !loading) {
  <div>
    <rs-alert [alert]='benefitAlert'></rs-alert>
  </div>
}
</div>
</rs-modal>
